import type {User} from "@/api/model/user";
import * as React from "react";
import {type DryingUnit, type DryingUnitData, LanguageLocale} from "@/api/model";
import useEmblaCarousel from "embla-carousel-react";
import type {CarouselApi} from "@/components/ui/carousel.tsx";

export declare type RootContextType = {
    user: User;
    l: LanguageLocale;
}
export const RootContext = React.createContext<RootContextType>({
    l: LanguageLocale.de,
    user: {} as unknown as User,
})

export declare type DryingUnitContextType = {
    dryingUnit: DryingUnit | undefined;
    refetch: () => Promise<unknown>;
    dryingUnitData: DryingUnitData | undefined;
    dataIsLoading: boolean,
}
export const DryingUnitContext = React.createContext<DryingUnitContextType>({
    refetch: () => {
        return Promise.resolve();
    },
    dryingUnit: undefined,
    dryingUnitData: undefined,
    dataIsLoading: false,
})

type UseCarouselParameters = Parameters<typeof useEmblaCarousel>
type CarouselOptions = UseCarouselParameters[0]
type CarouselPlugin = UseCarouselParameters[1]

export declare type CarouselProps = {
    opts?: CarouselOptions
    plugins?: CarouselPlugin
    orientation?: "horizontal" | "vertical"
    setApi?: (api: CarouselApi) => void
}

export declare type CarouselContextProps = {
    carouselRef: ReturnType<typeof useEmblaCarousel>[0]
    api: ReturnType<typeof useEmblaCarousel>[1]
    scrollPrev: () => void
    scrollNext: () => void
    canScrollPrev: boolean
    canScrollNext: boolean
} & CarouselProps

export const CarouselContext = React.createContext<CarouselContextProps | null>(null)
